import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  brandColours,
  fontWeights,
  fontSize,
  standardTransition,
} from '../styles';

const StyledBackToTop = styled.button`
  position: fixed;
  right: 0;
  bottom: 40px;
  display: flex;
  align-items: center;
  padding: 8px 10px;
  color: ${standardColours.white};
  font-weight: ${fontWeights.bold};
  ${fontSize(12)};
  background-color: ${brandColours.primary};
  border: none;
  transform: translate(100%);
  transition: ${standardTransition('transform')};

  ${minBreakpointQuery.small`
    ${fontSize(13)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(14)};
  `}

  ${({ show }) => {
    if (show) {
      return css`
        transform: translate(0);
      `;
    }
  }}
`;

const BackToTop = () => {
  const [showBackToTop, setShowBackToTop] = useState();

  useEffect(() => {
    document.addEventListener('scroll', () => {
      setShowBackToTop(window.scrollY > 200);
    });
  }, []);

  return (
    <StyledBackToTop
      show={showBackToTop}
      onClick={() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
    >
      Back to top
    </StyledBackToTop>
  );
};

export default BackToTop;
